<template>
	<div class="panel-lock p-4 text-muted text-center d-flex flex-column justify-content-center align-items-center h-100">
		<b-icon icon="lock-fill" font-scale="1.6" class="mb-2 text-warning"></b-icon>
		<p class="mb-2 small">{{ message }}</p>
		<b-badge variant="warning" style="cursor:pointer" @click="$root.$emit('show-upgrade-modal')">{{ pro ? 'Pro' : 'Upgrade' }}</b-badge>
	</div>
</template>

<script>
export default {
	name: 'PanelLock',
	props: {
		message: { type: String, default: 'This feature requires an upgrade.' },
		pro: { type: Boolean, default: false },
	},
};
</script>
